import { useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { AdvancedFilterButton, FilterPanelCollapse } from '@/components/common/AdvancedFilter';
import { BackButton } from '@/components/common/BackButton';
import { ExportButton } from '@/components/common/ExportButton';
import { PageHeader } from '@/components/layout/PageHeader';
import { FIT_TO_SCREEN_PAGE_CLASS } from '@/components/layout/page.constants';
import { useHistoryBack } from '@/hooks/useHistoryBack';
import { exportSurveySubmissions } from '../api/surveys.api';
import { SurveySubmissionFilterPanel } from '../components/SurveySubmissionFilterPanel';
import { SurveySubmissionListTable } from '../components/SurveySubmissionListTable';
import { useSurveySubmissionFilters } from '../hooks/useSurveySubmissionFilters';

export function SurveySubmissionsPage() {
  const { surveyId } = useParams({ from: '/_auth/feedback/surveys/$surveyId/submissions/' });
  const navigate = useNavigate();
  const goBack = useHistoryBack(
    () => void navigate({ to: '/feedback/surveys/$surveyId', params: { surveyId } }),
  );
  const controller = useSurveySubmissionFilters();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  return (
    <div className={FIT_TO_SCREEN_PAGE_CLASS}>
      <PageHeader
        title="Submissions"
        leading={<BackButton onClick={goBack} />}
        search={{
          value: controller.searchText,
          onChange: controller.setSearchText,
          placeholder: 'Search name, HR ID or mobile',
        }}
        actions={
          <>
            <AdvancedFilterButton
              isOpen={isFilterOpen}
              activeCount={controller.activeFilterCount}
              onClick={() => setIsFilterOpen((wasOpen) => !wasOpen)}
            />
            <ExportButton
              onExport={() => exportSurveySubmissions(surveyId, controller.exportParams)}
            />
          </>
        }
      />

      <FilterPanelCollapse isOpen={isFilterOpen}>
        <SurveySubmissionFilterPanel filters={controller} />
      </FilterPanelCollapse>

      <SurveySubmissionListTable
        surveyId={surveyId}
        listQueryParams={controller.listQueryParams}
        searchText={controller.appliedSearchText}
      />
    </div>
  );
}
